//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminDocumentController_findOneById,
  Response$AdminDocumentController_findOneById$Status$200,
  ResponseContentType$AdminDocumentController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminDocumentController_findOneById = (options: {
  params: Params$AdminDocumentController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminDocumentController_findOneById$Status$200[ResponseContentType$AdminDocumentController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminDocumentController_findOneById,
    Response$AdminDocumentController_findOneById$Status$200[ResponseContentType$AdminDocumentController_findOneById]
  >({
    method: 'AdminDocumentController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
